import React from 'react';
import Button from './common/Button';
import appLogo from '../assets/Apps.svg';

const ConsentCard = ({
	consent,
	isSelected,
	onSelect,
	onViewDetails,
	customDetails,
}) => {

	const dateFormat = (dateString) => {
		if (dateString) {
			let newDate = new Date(dateString);
			let dataArray = newDate.toString().split(' ');
			return `${dataArray[2]} ${dataArray[1]} ${dataArray[3]} ${dataArray[4]}`;
		}
	};

	const handleViewDetails = () =>{
		onViewDetails(
			consent?.consentIntentId,
			consent?.consentIntentEntityName,
			consent
		)
	}

	const getStatusColor = (status) => {
		switch (status) {
			case 'ACTIVE':
				return '#D9F8F4';
			case 'PAUSED':
				return '#FFF8EC';
			default:
				return '#D9DDF';
		}
	};

	return (
		<div className="col-12 mb-3">
			<div className="border border-1 border-black rounded-3 p-2 py-md-2 px-md-4 py-lg-2 px-lg-4">
				<div className="row p-2">
					<div className="col-6">
						<img
							src={!consent?.entityLogoUri ? appLogo : consent?.entityLogoUri}
							className="float-start mt-2"
							style={{ width: 'auto', height: 'auto', objectFit: 'contain' }}
							alt={consent?.consentIntentEntityName || 'Entity logo'}
						/>
					</div>
					<div className="col-6" style={{ alignSelf: 'center' }}>
						<div className="form-check form-check-inline float-end">
							<button
								type="button"
								role="checkbox"
								aria-checked={isSelected}
								aria-label={`Select consent for ${consent?.consentIntentEntityName}`}
								className="card-action-btn"
								onClick={() => onSelect(consent)}
								style={{
									width: '24px',
									height: '25px',
									borderRadius: '50%',
									display: 'inline-flex',
									alignItems: 'center',
									justifyContent: 'center',
									backgroundColor: isSelected
										? customDetails.primaryColor
										: '#fff',
									border: isSelected
										? `2px solid ${customDetails.primaryColor}`
										: '2px solid #6B6D6F',
								}}
							>
								{isSelected && (
									<svg
										width="12"
										height="10"
										viewBox="0 0 12 10"
										fill="none"
										aria-hidden="true"
									>
										<path
											d="M1 5L4.5 8.5L11 1.5"
											stroke="white"
											strokeWidth="2"
											strokeLinecap="round"
											strokeLinejoin="round"
										/>
									</svg>
								)}
							</button>
						</div>
					</div>
				</div>
				<div className="row p-2">
					<div className="col-12">
						<h2
							className="fw-700 text-start m-0"
							style={{
								color: customDetails.primaryColor,
								fontFamily: customDetails?.fontFamily,
								fontSize: '16px',
							}}
						>
							{consent?.consentIntentEntityName}
						</h2>
					</div>
					<div className="col-6">
						<p
							className="fs-12 fw-600 text-start mb-2"
							style={{ color: '#6B6D6F' }}
						>
							Purpose
						</p>
					</div>
					<div className="col-6">
						<p
							className="fs-12 fw-600 text-end mb-2"
							style={{ color: '#6B6D6F' }}
						>
							Consent given on
						</p>
					</div>
					<div className="col-7">
						<p className="fs-12 fw-600 text-black text-start">
							{consent?.consentPurposeText}
						</p>
					</div>
					<div className="col-5">
						<p className="fs-12 fw-600 text-black text-end">
							{dateFormat(consent?.consentIntentUpdateTimestamp)}
						</p>
					</div>
					<div className="row p-2 mt-auto">
						<div className="col-7 text-start">
							<span
								className="fs-12 fw-600 px-2 py-1 rounded-pill d-inline-block"
								role="status"
								aria-label={`Consent status: ${consent?.status}`}
								style={{ backgroundColor: getStatusColor(consent?.status) }}
							>
								{consent?.status}
							</span>
						</div>
						<div className="col-5 d-flex justify-content-end p-0">
							<Button
								className="fs-16 fw-700 bg-transparent border-0 rounded-3"
								style={{ color: customDetails.primaryColor }}
								onClick={handleViewDetails}
								aria-label={`View details for ${consent?.consentIntentEntityName}`}
							>
								DETAILS
							</Button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConsentCard;
